import * as $ from 'jquery';
import 'MagnificPopup';
import 'bootstrap';
import 'selectize';
import * as moment from 'moment';

export class travelSubsidy {
    
    loadIBEPopUp(): void {
        let _self = this;
        let cugContinue = $('.cug-ibe');
        cugContinue.off('click', '.cug-form-ibe').on('click', '.cug-form-ibe', (evt: any) => {
            evt.preventDefault();
            let $paramCug = $('#search-param-cug').val();
            let $paramCugmob = $('#search-param-cug-mobile').val();
            let $paramCugMatta = $('#search-param-cug-matta').val();
            let $matta_login_url = $('#matta_login_url').val();

            
            // RESETTING THE VALUES
                       
            let form:any= $(".ibe-standalone .location-container");
            var inputSelectArr = $.makeArray(form.find('select'));
				$.each(inputSelectArr,function(i:number, el:any){
                    if(el && el.selectize){
                        el.selectize.clear();
                    }
                   

                });	
                let cug_locationconatiner= $(".ibe-standalone").find('.location-container');
                cug_locationconatiner.find('.input-filled').removeClass('input-filled')
                let cug_searchconatiner= $(".ibe-standalone").find('.book-date--selector');
                cug_searchconatiner.find('.input-filled').removeClass('input-filled')
                $(".ibe-standalone").find('.has-error').removeClass('has-error');
                $(".ibe-standalone").find('.has-errors').removeClass('has-errors');
                $('.ibe-standalone .departureDate').val(''); 
                $('.ibe-standalone .departureDateMobile').val('');  
                $('.ibe-standalone .returnDate').val(''); 
                $('.ibe-standalone .returnDateMobile').val(''); 
                $('.ibe-standalone .dateDeparture').val('');
                $('.ibe-standalone .total-passengers').find('.total-nos').html("1");
                $('.ibe-standalone .minus-plus-input').val('0');
                $('.ibe-standalone .ticket-adult--input').val('1');
                $('.ibe-standalone .ticket-mob-adult--input').val('1');
               
        if($paramCugMatta)
        {
                    if (!_self.getCookie("sapphire")){
                     if($matta_login_url && $matta_login_url!=="undefined"){
                        window.location.href = $matta_login_url;
                    }

                    } 
                    else 
                    {
                        let cookieAccessToken = _self.getCookie("sapphire");
                        var decodedToken = parseJwt(cookieAccessToken);
                        
                        if (decodedToken.extension_flyerid && decodedToken.extension_flyerid !=="undefined")
                            {
                                $.magnificPopup.open({
                                    items: {
                                        src: '#ibe-standalone-camp'
                                    },
                                    type: 'inline',
                                    midClick: true,
                                    enableEscapeKey: false,
                                    showCloseBtn: false,
                                    closeOnBgClick: false,
                                    callbacks: {
                                        open: function () {
                                            let instance = this;
                                            let $el: any = instance.content;
                                            $el.css('border-bottom', 'none');
                                            let $closeIbe: any = $el.find('.close-booking');
                                            $('#mini-ibe-cta-button').val('1');
                                            $closeIbe.on('click', (e: any) => {
                                                $.magnificPopup.close();
                                            });
                                            var options1 = $el.find('.payment-method-options li label');
                                            var values1 = $.map(options1, function (option: any) {
                                                if (option.innerText.trim() != 'Card / Cash') {
                                                    option.classList.add('hide');
                                                }
                                            });
                                            // $el.find('.trip-type--container .multiCityTrip').addClass('hide');
                                            $el.find('.trip-type--container .roundTheWorldTrip').removeClass('visible-lg');
                                            $el.find('.trip-type--container .roundTheWorldTrip').addClass('hide');
                                            $el.find('.trip-type--container .sideTrip').addClass('hide');
                                            $el.find('.trip-type--container .ibe_sideTrip').addClass('hide');
                                            $el.find('.trip-type--container .multiCityTrip').addClass('hide');
                                            $el.find('.search-container .couponCode').addClass('hide');
                                            $el.find('#isSideTripEnable').val('No');                                                   
                                            if (window.innerWidth < 768) {
                                                $el.css({ 'padding': '0', 'height': '100%' });
                                                $el.parent().css({ 'height': '100%' });
                                                $el.parent().parent().css({ 'padding': '0' });
                                                $el.find('.mobile-ibe').css({ 'height': '100%', 'padding': '0' });
                                                $el.find('#mobile-bookflight--container').css({ 'height': '100%' });
                                                $('body').css('height', $(window).height());
                                                $('body').css('overflow', 'hidden');
                                            }
    
                                        },
                                        close: function () {
                                            $('#mini-ibe-cta-button').val('');
                                            if (window.innerWidth < 768) {
                                                $('body').css('overflow', '');
                                                $('body').css('height', ''); 
                                            }
    
                                        }
                                    }
                                }, 0);
                            }
                            else{
                                if($matta_login_url && $matta_login_url!=="undefined"){
                                    window.location.href = $matta_login_url;
                                }     
                            }
                       }
     
            }
            else if($paramCug || $paramCugmob )
            {
            $.magnificPopup.open({
                items: {
                    src: '#ibe-standaloneq'
                },
                type: 'inline',
                midClick: true,
                enableEscapeKey: false,
                showCloseBtn: false,
                closeOnBgClick: false,
                callbacks: {
                    open: function () {
                        let instance = this;
                        let $el: any = instance.content;
                        $el.css('border-bottom', 'none');
                        let $closeIbe: any = $el.find('.close-booking');
                        $('#mini-ibe-cta-button').val('1');
                        $closeIbe.on('click', (e: any) => {
                            $.magnificPopup.close();
                        });
                        var options1 = $el.find('.payment-method-options li label');
                        var values1 = $.map(options1, function (option: any) {
                            if (option.innerText.trim() != 'Card / Cash') {
                                option.classList.add('hide');
                            }
                        });
                        // $el.find('.trip-type--container .multiCityTrip').addClass('hide');
                        $el.find('.trip-type--container .roundTheWorldTrip').removeClass('visible-lg');
                        $el.find('.trip-type--container .roundTheWorldTrip').addClass('hide');
                        $el.find('.trip-type--container .sideTrip').addClass('hide');
                        $el.find('.trip-type--container .ibe_sideTrip').addClass('hide');
                        $el.find('#isSideTripEnable').val('No');
                        let ibeNowDate:any      = new Date();	
                        if(($('[data-cug-bookingmindays]').attr('data-cug-bookingmindays')||$('[data-cug-bookingmaxdays]').attr('data-cug-bookingmaxdays')!=""))
                        {
                            let cugMaxdays: any = new Date($('[data-cug-maxdays]').attr('data-cug-maxdays'));	    
                            let minLimitDate: any = new Date(cugMaxdays.getFullYear(), cugMaxdays.getMonth(), cugMaxdays.getDate(), 0, 0, 0, 0);
                            $el.find('.departureDate.oneWay-trip').datepicker('option', 'maxDate', minLimitDate);
                            $el.find('.departureDate').datepicker('option', 'maxDate', minLimitDate);
                            $('.ibe-standalone .returnDate').datepicker('option', 'maxDate', minLimitDate);
                            $el.find('.departureDateMobile.oneWay-trip').datepicker('option', 'maxDate', minLimitDate);
                            $el.find('.departureDateMobile').datepicker('option', 'maxDate', minLimitDate);
                            $el.find('.returnDateMobile').datepicker('option', 'maxDate', minLimitDate);		
                            $('.dateDeparture').datepicker('option', 'maxDate', minLimitDate);
    
    
                            // let cugMindays: any = new Date($('[data-cug-mindays]').attr('data-cug-mindays'));
                            var currentDate = new Date();
                            var minDate = new Date($('[data-cug-mindays]').attr('data-cug-mindays'));
                            let cugMindays: any =  minDate>currentDate ? new Date($('[data-cug-mindays]').attr('data-cug-mindays')) : new Date();;
                            let maxLimitDate: any = new Date(cugMindays.getFullYear(), cugMindays.getMonth(), cugMindays.getDate(), 0, 0, 0, 0);
                            $el.find('.departureDate.oneWay-trip').datepicker('option', 'minDate', maxLimitDate);
                            $el.find('.departureDate').datepicker('option', 'minDate', maxLimitDate);
                            $el.find('.returnDate').datepicker('option', 'minDate', maxLimitDate);
                            $el.find('.departureDateMobile.oneWay-trip').datepicker('option', 'minDate', maxLimitDate);
                            $el.find('.departureDateMobile').datepicker('option', 'minDate', maxLimitDate);
                            $el.find('.returnDateMobile').datepicker('option', 'minDate', maxLimitDate);
                            $('.dateDeparture').datepicker('option', 'minDate', maxLimitDate);
                        }
                        if (window.innerWidth < 768) {
                            $el.css({ 'padding': '0', 'height': '100%' });
                            $el.parent().css({ 'height': '100%' });
                            $el.parent().parent().css({ 'padding': '0' });
                            $el.find('.mobile-ibe').css({ 'height': '100%', 'padding': '0' });
                            $el.find('#mobile-bookflight--container').css({ 'height': '100%' });
                            $('body').css('height', $(window).height());
                            $('body').css('overflow', 'hidden');
                        }

                    },
                    close: function () {
                        $('#mini-ibe-cta-button').val('');
                        if (window.innerWidth < 768) {
                            $('body').css('overflow', '');
                            $('body').css('height', ''); 
                        }

                    }
                }
            }, 0);
        }
        else
        {
            $.magnificPopup.open({
                items: {
                    src: '#ibe-standalone-camp'
                },
                type: 'inline',
                midClick: true,
                enableEscapeKey: false,
                showCloseBtn: false,
                closeOnBgClick: false,
                callbacks: {
                    open: function () {
                        let instance = this;
                        let $el: any = instance.content;
                        $el.css('border-bottom', 'none');
                        let $closeIbe: any = $el.find('.close-booking');
                        $('#mini-ibe-cta-button').val('1');
                        $closeIbe.on('click', (e: any) => {
                            $.magnificPopup.close();
                        });
                        var options1 = $el.find('.payment-method-options li label');
                        // var values1 = $.map(options1, function (option: any) {
                        //     if (option.innerText.trim() != 'Card / Cash') {
                        //         option.classList.add('hide');
                        //     }
                        // });
                        // $el.find('.trip-type--container .multiCityTrip').addClass('hide');
                        $el.find('.trip-type--container .sideTrip').addClass('hide');
                        $el.find('.trip-type--container .ibe_sideTrip').addClass('hide');
                        $el.find('#isSideTripEnable').val('No');
                        let ibeNowDate:any      = new Date();	
                        if(($('[data-cug-bookingmindays]').attr('data-cug-bookingmindays')||$('[data-cug-bookingmaxdays]').attr('data-cug-bookingmaxdays')!=""))
                        {
                        let cugMaxdays: any = new Date($('[data-cug-maxdays]').attr('data-cug-maxdays'));	    
                        let minLimitDate: any = new Date(cugMaxdays.getFullYear(), cugMaxdays.getMonth(), cugMaxdays.getDate(), 0, 0, 0, 0);
                        $el.find('.departureDate.oneWay-trip').datepicker('option', 'maxDate', minLimitDate);
                        $el.find('.departureDate').datepicker('option', 'maxDate', minLimitDate);
                        $('.ibe-standalone .returnDate').datepicker('option', 'maxDate', minLimitDate);
                        $el.find('.departureDateMobile.oneWay-trip').datepicker('option', 'maxDate', minLimitDate);
                        $el.find('.departureDateMobile').datepicker('option', 'maxDate', minLimitDate);
                        $el.find('.returnDateMobile').datepicker('option', 'maxDate', minLimitDate);		
                        $('.dateDeparture').datepicker('option', 'maxDate', minLimitDate);


                        // let cugMindays: any = new Date($('[data-cug-mindays]').attr('data-cug-mindays'));
                        var currentDate = new Date();
                        var minDate = new Date($('[data-cug-mindays]').attr('data-cug-mindays'));
                        let cugMindays: any =  minDate>currentDate ? new Date($('[data-cug-mindays]').attr('data-cug-mindays')) : new Date();;
                        let maxLimitDate: any = new Date(cugMindays.getFullYear(), cugMindays.getMonth(), cugMindays.getDate(), 0, 0, 0, 0);
                        $el.find('.departureDate.oneWay-trip').datepicker('option', 'minDate', maxLimitDate);
                        $el.find('.departureDate').datepicker('option', 'minDate', maxLimitDate);
                        $el.find('.returnDate').datepicker('option', 'minDate', maxLimitDate);
                        $el.find('.departureDateMobile.oneWay-trip').datepicker('option', 'minDate', maxLimitDate);
                        $el.find('.departureDateMobile').datepicker('option', 'minDate', maxLimitDate);
                        $el.find('.returnDateMobile').datepicker('option', 'minDate', maxLimitDate);
                        $('.dateDeparture').datepicker('option', 'minDate', maxLimitDate);
                        }
                        if (window.innerWidth < 768) {
                            $el.css({ 'padding': '0', 'height': '100%' });
                            $el.parent().css({ 'height': '100%' });
                            $el.parent().parent().css({ 'padding': '0' });
                            $el.find('.mobile-ibe').css({ 'height': '100%', 'padding': '0' });
                            $el.find('#mobile-bookflight--container').css({ 'height': '100%' });
                            $('body').css('height', $(window).height());
                            $('body').css('overflow', 'hidden');
                        }

                    },
                    close: function () {
                        $('#mini-ibe-cta-button').val('');
                        if (window.innerWidth < 768) {
                            $('body').css('overflow', '');
                            $('body').css('height', ''); 
                        }

                    }
                }
            }, 0);
        }
        });
        	
	function parseJwt (token:any): any {
		var base64Url = token.split('.')[1];
		var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	
		return JSON.parse(base64);
	};
    
    }
    getCookie(name:string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal:any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}
}

let scope: Element = document.querySelector('.cug-container');
if (scope) {
    try {
        let travelsubsidy = new travelSubsidy();
        travelsubsidy.loadIBEPopUp();

        var currentDate = new Date();
        var minDate = new Date($('[data-cug-bookingmindays]').attr('data-cug-bookingmindays'));
        var maxDate =  new Date($('[data-cug-bookingmaxdays]').attr('data-cug-bookingmaxdays'));
   if(($('[data-cug-bookingmindays]').attr('data-cug-bookingmindays')||$('[data-cug-bookingmaxdays]').attr('data-cug-bookingmaxdays')!=""))
   {
        if (currentDate > minDate && currentDate < maxDate ){
           //booking period  is correct
        }
        else{
            $( "<div class=cug-bookingperiod style=COLOR:RED;padding-left:18px;>Booking not allowed.Kindly check the booking period.</div>").insertAfter($( " .ibe-standalone .trip-container " ))
            $("#ibe-standaloneq").css({ 'pointer-events': 'none' });
            $( ".ibe-standalone .close-container " ).css({ 'pointer-events': 'auto' });
            $("#ibe-standalone-camp").css({ 'pointer-events': 'none' });
            $("#ibe-standalone-matta-camp-error").css({ 'pointer-events': 'none' });
           
        }
    }
    } catch (e) { console.error(e); }
}